export const unities: { [key: string]: string; } = {
  liter: 'L',
  kilometers: 'Km',
  hours: 'H',
  item: 'un',
  gram: 'g',
  cubic_meter: 'm³',
}

export const unitiesDecimals: { [key: keyof typeof unities]: number; } = {
  liter: 2,
  kilometers: 2,
  hours: 2,
  item: 0,
  gram: 2,
  cubic_meter: 2,
}
